import React, { useState, useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress,
    InputGroup, InputRightElement, Icon, IconButton,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, ModalFooter
} from '@chakra-ui/react';
import { MdSave, MdClose } from 'react-icons/md';
import { Form, Field } from 'react-final-form';
import validator from "validator";

function AddEditEnterpriseModal({ 
    company_id, enterpriseDetail, actionStatus, initialRef, isOpen, onClose, 
    apiCreateNewEnterprise, apiUpdateAEnterprise,  
}) {
    const [ isValidPhone, setIsValidPhone ] = useState(true);
    const [ isValidEmail, setIsValidEmail ] = useState(true);
    const [ isProcessing, setIsProcessing ] = useState(false);
    const [ cookies ] = useCookies(["loginCookie"]);

    useEffect(() => {
        if(!actionStatus) {
            setIsProcessing(false);
        }
    }, [actionStatus]);

    const validate = (values) => {
        const errors = {};

        if(!values.name) {
            errors.name = "Required";
        }
        if(!values.representative) {
            errors.representative = "Required";
        }
        // if(!values.phone) {
        //     errors.phone = "Required";
        // }
        if(values.phone?.length > 0) {
            const isValidPhone = validator.isMobilePhone(values.phone, "vi-VN");
            setIsValidPhone(isValidPhone);
            if(!isValidPhone) {
                errors.validPhone = "Required";
            }
        }

        if(values.email?.length > 0) {
            const isValidEmail = validator.isEmail(values.email);
            setIsValidEmail(isValidEmail);
            if(!isValidEmail) {
                errors.validEmail = "Required";
            }
        }
        
        return errors;
    }

    const onSubmit = async(values) => {
        setIsProcessing(true);
        if(enterpriseDetail && enterpriseDetail.id) {
            apiUpdateAEnterprise({ 
                id: enterpriseDetail.id, 
                payload: {
                    ...values,
                    user_id: cookies?.loginCookie?.data?.id,  
                } 
            });
        } else {
            apiCreateNewEnterprise({ 
                ...values,
                user_id: cookies?.loginCookie?.data?.id,   
            });
        }
    }

    return (
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size="lg">
            <ModalOverlay />
            <Form
                onSubmit={onSubmit}
                initialValues={{
                    company_id,
                    ...enterpriseDetail
                }}
                validate={validate}
                render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <ModalContent>
                                <ModalHeader>
                                    { enterpriseDetail && enterpriseDetail.id ? "CẬP NHẬT" : "TẠO MỚI" }
                                </ModalHeader>
                                <ModalCloseButton />

                                <ModalBody pb={6}>
                                    <Field name="name">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Tên Doanh nghiệp</FormLabel>
                                                <Input {...input} type='text' placeholder='Nhập tên' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="representative">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Người Đại Diện</FormLabel>
                                                <Input {...input} type='text' placeholder='Nhập người đại diện' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="phone">
                                        {({ input, meta }) => (
                                            <FormControl mt={4}>
                                                <FormLabel>Số Điện Thoại</FormLabel>
                                                <Input {...input} type="tel" placeholder='Nhập số điện thoại' />
                                                {
                                                    !isValidPhone &&
                                                    <FormLabel color="red">Nhập đúng Số Điện Thoại</FormLabel>
                                                }
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="email">
                                        {({ input, meta }) => (
                                            <FormControl>
                                                <FormLabel>Email</FormLabel>
                                                <Input {...input} type="email" placeholder='Nhập email' />
                                                {
                                                    !isValidEmail &&
                                                    <FormLabel color="red">Nhập đúng Email</FormLabel>
                                                }
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="address">
                                        {({ input, meta }) => (
                                            <FormControl>
                                                <FormLabel>Địa chỉ</FormLabel>
                                                <Input {...input} type='text' placeholder='Nhập địa chỉ' />
                                            </FormControl>
                                        )}
                                    </Field>
                                </ModalBody>

                                <ModalFooter>
                                    <Button colorScheme='blue' mr={3} type='submit' isDisabled={!valid | pristine}
                                        isLoading={isProcessing}
                                        loadingText="Đang lưu"
                                    >
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">Lưu</Text>
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </form>
                    )
                }}
            />
        </Modal>
    )
}

export default AddEditEnterpriseModal;